var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-app-bar',{attrs:{"color":"primary"}},[_c('v-spacer'),_c('v-app-bar-title',{staticClass:"white--text"},[_vm._v("粗大ごみ回収依頼メール")]),_c('v-spacer')],1),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }